export default __webpack_public_path__ + "8050ffc680a6e7a8971a1c0eb5798507.png";